import { render } from "./DeleteAction.vue?vue&type=template&id=32e01fe6"
import script from "./DeleteAction.vue?vue&type=script&lang=ts"
export * from "./DeleteAction.vue?vue&type=script&lang=ts"
script.render = render

export default script